<app-public-hero></app-public-hero>
<app-public-engage></app-public-engage>
<app-public-ideas></app-public-ideas>
<!-- <app-map></app-map> -->
<app-officialized-cities></app-officialized-cities>
<mat-divider></mat-divider>
<app-category-news></app-category-news>
<app-leader></app-leader>
<app-depositions></app-depositions>
<app-donors></app-donors>